import { render } from "./AboutMoovePage.vue?vue&type=template&id=709a12dc&scoped=true"
import script from "./AboutMoovePage.vue?vue&type=script&lang=js"
export * from "./AboutMoovePage.vue?vue&type=script&lang=js"

import "./AboutMoovePage.vue?vue&type=style&index=0&id=709a12dc&scoped=true&lang=css"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709a12dc"]])

export default __exports__